import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { ValidationErrors } from '@angular/forms'
import { MatMenuPanel } from '@angular/material/menu'
import { TrackingService } from '../../_jaettu-angular/tracking'

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconButtonComponent {
  @Input() actionId: string
  @Input() actionContext: any[]
  @Input() additionalClass: string = ''
  @Input() dynamicClass: { [klass: string]: boolean } = {}
  @Input() styles: string = ''
  @Input() matIcon: string = ''
  @Input() disabled: boolean | ValidationErrors = false
  @Input() ariaLabel: string = ''
  /** Painike avaa valikon jaetulla käynnistimellä, joka päivittää aria-expanded-tilan itse; painike antaa vain alkutilan. */
  @Input() ariaHaspopup: 'menu' | null = null
  @Input() matMenuTrigger?: MatMenuPanel
  @Input() matMenuTriggerData?: any

  constructor(private _trackingService: TrackingService) {}

  async trackButton() {
    const context = ''
    // if (this.actionContext && this.actionContext.length > 0) {
    //   for (const cntxt of this.actionContext) {
    //     context += JSON.stringify(cntxt)
    //   }
    // }
    this._trackingService.logAction(`${this.actionId} ${context}`)
  }
}
